import React, { useState } from "react";
import { createContext, useContext } from "react";

const MenuContext = createContext();
const MenuUpdateContext = createContext();

export function useMenu() {
  return useContext(MenuContext);
}

export function useMenuUpdate() {
  return useContext(MenuUpdateContext);
}

const PushContext = createContext();
const PushUpdateContext = createContext();

export function usePush() {
  return useContext(PushContext);
}

export function usePushUpdate() {
  return useContext(PushUpdateContext);
}

const UserEmailContext = createContext();
const UserEmailUpdateContext = createContext();

export function useUserEmail() {
  return useContext(UserEmailContext);
}

export function useUserEmailUpdate() {
  return useContext(UserEmailUpdateContext);
}

const UserNameContext = createContext();
const UserNameUpdateContext = createContext();

export function useUserName() {
  return useContext(UserNameContext);
}

export function useUserNameUpdate() {
  return useContext(UserNameUpdateContext);
}

export function MenuProvider({ children }) {
  const [menu, setMenu] = useState(false);
  const [push, setPush] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");

  function toggleMenu() {
    setMenu(!menu);
  }

  function togglePush() {
    setPush(!push);
  }

  function setEmail(email) {
    setUserEmail(email);
  }

  function setName(name) {
    setUserName(name);
  }

  return (
    <MenuContext.Provider value={menu}>
      <MenuUpdateContext.Provider value={toggleMenu}>
        <UserNameContext.Provider value={userName}>
          <UserNameUpdateContext.Provider value={setName}>
            <UserEmailContext.Provider value={userEmail}>
              <UserEmailUpdateContext.Provider value={setEmail}>
                <PushContext.Provider value={push}>
                  <PushUpdateContext.Provider value={togglePush}>
                    {children}
                  </PushUpdateContext.Provider>
                </PushContext.Provider>
              </UserEmailUpdateContext.Provider>
            </UserEmailContext.Provider>
          </UserNameUpdateContext.Provider>
        </UserNameContext.Provider>
      </MenuUpdateContext.Provider>
    </MenuContext.Provider>
  );
}
